import hero from "@/assets/hero.webp";
import heroSm from "@/assets/hero-720.webp";

export const HERO_IMAGE = hero;
export const HERO_IMAGE_SM = heroSm;
export const HERO_WIDTH = 900;
export const HERO_HEIGHT = 1080;
export const HERO_SRCSET = `${heroSm} 720w, ${hero} 900w`;
export const HERO_SIZES = "(min-width: 1024px) 42vw, 100vw";
